export function transformCatalogItemToOrderItem() {
  var catalogItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var variationId = catalogItem.selectedVariation._id,
    selectedModifiers = catalogItem.selectedModifiers,
    quantity = catalogItem.quantity,
    instructions = catalogItem.specialInstructions;
  var orderItem = {
    object_id: variationId,
    modifiers: selectedModifiers.map(function (_ref) {
      var modifierId = _ref._id;
      return {
        object_id: modifierId
      };
    }),
    quantity: quantity,
    instructions: instructions
  };
  return orderItem;
}
export function getOrderStorageKey(baseKey, productUuid, locationUuid) {
  return "".concat(baseKey, "_").concat(productUuid, "_").concat(locationUuid);
}